import TagManager from "react-gtm-module"

function tagData(values) {
  TagManager.dataLayer({
    dataLayer: { ...values },
  })
}

// 1. Cinema Location ---> DONE
export const dataLayerCinemaLocation = (payload) => tagData(payload)

// 2. Burger Menu ---> DONE
export const dataLayerClickBurgerMenu = (payload) => {
  tagData({
    event: "click_menu",
    ...payload,
  })
}

// 3 Click Sosmed ---> DONE
export const dataLayerClickSosmedMenu = (payload) => {
  tagData({ event: "click_socmed", ...payload })
}

// 4 Play Video Homepage --> DONE
export const dataLayerPlayVideoHomePage = (payload) => {
  tagData({ event: "play_video", ...payload })
}

// 5 Click product --> DONE
export const dataLayerProductServices = (payload) => {
  tagData({ event: "click_product", ...payload })
}

// 6 Food & Beverages --> DONE
export const dataLayerFoodBeverages = (payload) => {
  tagData({ event: "click_food", ...payload })
}

// 7 Click Experience
export const dataLayerClickExperience = (payload) => {
  tagData({ event: "click_experiences", ...payload })
}

//! 8 Click Festival
export const dataLayerClickFestival = (payload) => {
  tagData({ event: "click_festival", ...payload })
}

//! 9 Click Digital Product
export const dataLayerDigitalProduct = (payload) => {
  tagData({
    event: "download_mtix",
    ...payload,
  })
}
